import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function StudentprotectedRoute(props) {
  const { Component } = props;
  const navigate = useNavigate();

  useEffect(() => {
    let userType = localStorage.getItem('userType');

    if (!userType) {
      navigate('/login');
    } else if (userType === 'Employer') {
      navigate('/notfound');
    }
  }, [navigate]);

  return <>{localStorage.getItem('userType') === 'User' ? <Component /> : null}</>;
}

export default StudentprotectedRoute;
